import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {ComputationTypes} from "../../models/computation-types.data";
import {AcrResults} from "../../models/acr-results.model";
import {Patient} from "../../models/patient.model";
import {ChocResults} from "../../models/choc-results.model";
import {IsrResults} from "../../models/isr-results.model";
import {HticResults} from "../../models/htic-results.model";
import {SedationResults} from "../../models/sedation-results.model";

@IonicPage()
@Component({
  selector: 'page-results',
  templateUrl: 'results.html',
})
export class ResultsPage {

  computationKey: string;
  computationTypes = ComputationTypes;
  patient: Patient;
  acrResults: AcrResults;
  chocResults: ChocResults;
  isrResults: IsrResults;
  sedationResults: SedationResults;
  hticResults: HticResults;

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public navParams: NavParams) {
    this.computationKey = navParams.get('computationKey');
    this.patient = navParams.get('patient');
    if (this.computationKey === 'acr') {
      this.acrResults = new AcrResults(this.patient);
    }
    if (this.computationKey === 'choc' ) {
      this.chocResults = new ChocResults(this.patient);
    }
    if (this.computationKey === 'isr' ) {
      this.isrResults = new IsrResults(this.patient);
    }
    if (this.computationKey === 'sedation' ) {
      this.sedationResults = new SedationResults(this.patient);
    }
    if (this.computationKey === 'htic' ) {
      this.hticResults = new HticResults(this.patient);
    }

  }

  ionViewDidLoad() {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/results/results.ts